import __CONTACT from './Contact';

const Components = {
    Contact : __CONTACT
}

export default Components;